<template>
    <div class="gauge">
        <div
                class="gauge-pointer"
                :class="loading?'animated':''"
                :style="rotationStyle"/>
        <div class="limit bottom">0%</div>
        <div class="limit top">100%</div>
    </div>
</template>

<script>
    export default {
        props: [
            'loading',
            'value'
        ],
        computed: {
            rotationStyle() {
                return {
                    transform: 'rotate( ' + this.rotation + 'deg )'
                }
            },
            rotation() {
                return !this.loading
                    ? this.value * 180 / 100
                    : 150;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../styles/animations.scss';

    .gauge {
        display: block;
        height: 150px;
        width: 220px;
        margin: 0 auto 30px;
        background: url("../assets/gauge.svg") no-repeat;
        background-size: contain;
        position: relative;
    }

    .limit {
        background: #fff;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
        border-radius: 4px;
        width: 50px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        color: #A0A0A0;
        font-weight: bold;
        position: absolute;
        font-size: 14px;

        &.bottom {
            left: -7px;
            bottom: 7px;
        }

        &.top {
            right: -7px;
            bottom: 7px;
        }
    }

    .gauge-pointer {
        display: block;
        height: 144px;
        width: 150px;
        background: url("../assets/gauge-pointer.svg") no-repeat;
        transform-origin: 89px 19px;
        position: absolute;
        bottom: -68px;
        left: 20px;
        transform: rotate(0deg);
        transition: transform 2s;

        &.animated {
            animation: rotateGauge 2.9s;
            animation-timing-function: ease-in-out;
        }

        /** Origin */
        &::after {
            position: absolute;
            top: 100%;
            left: 0;
            width: 2px;
            height: 2px;
            content: '';
            background-color: transparent;
            border-radius: 50%;
            transform: translate(89px, -127px)
        }
    }
</style>